// ------------------------------------
// Reposiciona os elementos dependendo do tamanho da tela
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $reppends = $('[data-reppend-to]');

  // Percorre e reposiciona os elementos
  function reppendExec() {
    $reppends.each(function () {
      const $el = $(this);
      const $containerDest = $($el.data('reppend-to'));
      const $containerOrigin = $($el.data('reppend-origin'));
      const sizes = $el.data('reppend-sizes') ? $el.data('reppend-sizes').split(',') : ['sm', 'xs'];
      // Verifica se o novo container existe
      if ($containerDest.length > 0) {
        // Verifica o tamanho da tela
        if (sizes.indexOf(getMedia()) !== -1 && $containerDest.html().trim() == '') {
          // Reposiciona o elemento
          $el.appendTo($containerDest);
        } else if (
          sizes.indexOf(getMedia()) === -1 &&
          $containerOrigin.length > 0 &&
          $containerOrigin.html().trim() == '' &&
          $containerDest.html().trim() != ''
        ) {
          $el.appendTo($containerOrigin);
        }
      } else {
        console.log(`REPPEND: O novo container '${$el.data('reppend-to')}' não foi encontrado.`);
      }
    });
  }
  reppendExec();

  // Reposiciona os elementos ao alterar o tamanho da tela
  $(window).on(
    'resize orientationchange reppend',
    debounce(function () {
      reppendExec();
    }, 50),
  );
})();
